import React from 'react';
import PropTypes from 'prop-types';
import ModalLoginComponent from '../components/ModalLogin';
import ModalVerifyAccountComponent from "../components/ModalVerifyAccount";
import SpinnerWrapper from '../helpers/SpinnerWrapper';

import { Layout } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import { SET_MODAL } from '../constants';

import './view.css';

const AppLayoutBase = ({ children }) => {
  const dispatch = useDispatch();
  const onHide = () => dispatch({ type: SET_MODAL, key: 'login', val: false });
  const onHideVerify = () => dispatch({ type: SET_MODAL, key: 'verifyAccount', val: false });
  const auth = !!useSelector(state => state.authentication.authToken);

  return (
    <Layout>
      {children}
      {!auth && <ModalLoginComponent id="loginForm" onHide={onHide} />}
      <ModalVerifyAccountComponent id="verifyAccount" onHide={onHideVerify}  />
    </Layout>
  );
};


AppLayoutBase.propTypes = {
  children: PropTypes.node.isRequired,
};

// Default export for the Layout + spinner while loading
export default SpinnerWrapper()(AppLayoutBase);
// Named export for the Layout without the spinner
export { AppLayoutBase };
